export default __webpack_public_path__ + "static/media/image4.864e355c.jpg";